import React, { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { CreateCarRentalItemViewModel } from './models'
import { CreateItemProps, createCarRentalPayloadFromViewModel } from './utils'
import { formOptions } from '../Common/Fields/config'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import CarFields from 'tripPlanner/components/TripModal/TripItems/Common/CarFields'
import { useCreateTripItem } from 'tripPlanner/hooks/api/tripItem'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import { scrollToNewItemWithRetry } from 'tripPlanner/utils/scrollToNewItem'

function CreateCar(props: CreateItemProps) {
  const { tripId, defaultDate, rankSpec } = props

  const { closeModal, goBack } = useModalCallbacks()
  const methods = useForm<CreateCarRentalItemViewModel>({
    ...formOptions,
    defaultValues: {
      type: 'CAR_RENTAL',
      sourceType: 'NA',
      isBooked: false,
      startDate: defaultDate,
      endDate: defaultDate,
      startPlace: {},
      endPlace: {},
      isEndPlaceSame: false,
      isEndDateSame: false,
    },
  })
  const { handleSubmit } = methods

  const { mutate: createMutate, isLoading } = useCreateTripItem({
    onSuccess: (res) => {
      scrollToNewItemWithRetry(res.id)
      closeModal()
    },
  })

  const createCarItem = useCallback(
    (viewModel: CreateCarRentalItemViewModel) => {
      createMutate({
        tripId,
        tripItem: createCarRentalPayloadFromViewModel(viewModel),
        rankSpec,
      })
    },
    [createMutate, tripId, rankSpec],
  )

  return (
    <>
      <ModalHeader
        title="Add car rental"
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <FormProvider {...methods}>
        <ModalBody>
          <ModalContent>
            <CarFields tripId={tripId} />
          </ModalContent>
        </ModalBody>

        <ModalFooter
          primaryActionProps={{
            onClick: handleSubmit(createCarItem),
            children: 'Save',
            disabled: isLoading,
          }}
        />
      </FormProvider>
      {isLoading && <LoadingIndicator floating />}
    </>
  )
}

export default CreateCar
